export enum SidebarMenuEnum {
    HOME = 'Home',

    PTA = 'Premium Transportation Auth',
    PTA_EXISTING_REQUESTS = 'Existing Request',
    PTA_NEW_REQUEST = 'Create New Request',

    RFA = 'Route Frequency Adjustments',
    UPDATE_LPS_ROUTES = 'Planned Routes - Update LPS Records',
    CONFIRM_LPS_ROUTES = 'Planned Routes - Confirm LPS Records',

    SIGN_OFFS = 'Sign Offs',
    SUPPLIER_DASHBOARD = 'Supplier Dashboard',
    CARRIER_DASHBOARD = 'Carrier Dashboard',
    ENGINEERING_DASHBOARD = 'Engineering Dashboard',

    RELEASE_HUB = 'Release Hub',
    TICKETS_DASHBOARD = 'Tickets Dashboard',
    TEST_CASES = 'Test Cases',
    LOG_TICKET = 'Log Ticket',
    TICKET_QUEUE = 'Ticket Queue',

    SETTINGS = 'Settings',
    USER_MANAGEMENT = 'User Management',
    LOOKUPS_MANAGEMENT = 'Lookups Management',
    SIGNOFF_CONTACTS = 'Signoff Contacts',
    PTA_CONFIG = 'Master Data Management',
    ROLE_PERMISSIONS = 'Role Permissions',
}